import { Component, inject } from '@angular/core';
import { GS1AccordionComponent, GS1AccordionItemComponent, GS1CardComponent } from '@gs1france/gs1-components-library';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TagsService } from '../../core/services/tags.service';

@Component({
  selector: 'app-home-faq',
  imports: [GS1CardComponent, GS1AccordionComponent, GS1AccordionItemComponent, TranslateModule],
  templateUrl: './home-faq.component.html',
  styleUrls: ['./home-faq.component.scss']
})
export class HomeFaqComponent {
  translationService = inject(TranslateService);
  private tagsService = inject(TagsService);
  private readonly trackedQuestions = new Set<string>(this.readTrackedQuestions());

  faqs = Array.from({ length: 5 }, (_, i) => ({
    question: this.translationService.instant(`home.faq.question-${i + 1}`),
    answer: this.translationService.instant(`home.faq.answer-${i + 1}`)
  }));

  trackContact(method: 'Par mail' | 'Par téléphone'): void {
    this.tagsService.sendEvent('clic_centre_aide', { moyen_contact: method });
  }

  trackQuestionOpened(index: number): void {
    const question = this.faqs[index]?.question;
    if (!question || this.trackedQuestions.has(question)) return;

    this.trackedQuestions.add(question);
    sessionStorage.setItem('gtm-clic-faq-questions', JSON.stringify([...this.trackedQuestions]));
    this.tagsService.sendEvent('clic_FAQ', { question });
  }

  private readTrackedQuestions(): string[] {
    try {
      const trackedQuestions = JSON.parse(sessionStorage.getItem('gtm-clic-faq-questions') ?? '[]');
      return Array.isArray(trackedQuestions) ? trackedQuestions.filter((question): question is string => typeof question === 'string') : [];
    } catch {
      return [];
    }
  }
}
